import { useCorporateFormContext } from 'src/components/enterprise/features/Corporate/components/Form/CorporateFormProvider/useCorporateFormContext';
import {
  GroupRestrictions,
  groupRestrictions,
  transformEntityItemRestrictions,
} from 'src/common/OrderRestrictions/orderRestrictions.utils';

import {
  useOrderRestrictionContext,
  OrderRestrictionsContextType,
} from 'src/common/OrderRestrictions/OrderRestrictionsProvider/OrderRestrictionsProvider';

type UseCorporateItemRestrictionsReturn = {
  groupedItemRestrictions: GroupRestrictions;
} & OrderRestrictionsContextType;

export function useCorporateItemRestrictions(): UseCorporateItemRestrictionsReturn {
  const { corpData } = useCorporateFormContext();
  const { isLoading, itemRestrictionsMeta, error } =
    useOrderRestrictionContext();

  const getGroupedItemRestrictions = (): GroupRestrictions => {
    if (error && corpData?.defaultItemRestrictions) {
      return groupRestrictions(
        transformEntityItemRestrictions(corpData.defaultItemRestrictions)
      );
    }
    return groupRestrictions(itemRestrictionsMeta || []);
  };

  return {
    itemRestrictionsMeta,
    isLoading,
    groupedItemRestrictions: getGroupedItemRestrictions(),
  };
}
